import { Link } from "react-router-dom";

export default function SubmitCta() {
  return (
    <section className="relative w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20abstract%20illustration%20of%20glowing%20paper%20planes%20and%20light%20streaks%20against%20a%20deep%20warm%20amber%20gradient%2C%20soft%20haze%2C%20minimal%20elegant%20composition%2C%20no%20text&width=1600&height=700&seq=bl91-submit-cta&orientation=landscape"
        alt="投稿线索的抽象光效背景"
        title="爆料91 投稿爆料"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-16 md:py-20">
        <div className="max-w-2xl">
          <h2 className="text-2xl md:text-4xl font-black text-white font-heading leading-tight">
            你看到的讨论，可能就是下一个话题
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-white/85">
            如果你在评论区看到了值得被更多人看到的观点，或者手上有可被公开验证的线索，欢迎提交给我们。我们会先核实公开信息，再决定是否整理成话题。
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-accent-500 text-primary-950 text-sm md:text-base font-black whitespace-nowrap hover:bg-accent-400 transition-colors"
            >
              <i className="ri-send-plane-fill"></i>
              投稿爆料线索
            </Link>
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-background-50/12 backdrop-blur border border-background-50/35 text-background-50 text-sm md:text-base font-bold whitespace-nowrap hover:bg-background-50/20 transition-colors"
            >
              先看看大家都在聊什么
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}